export class PriorityModel {
  name: string;
  customerNumber: string;
}
